import { Component, Input, OnInit } from '@angular/core';
import { HrefResolverService } from '@blk/cwp-ng-framework';

import { AdditionalButton, FilterItem, TopPanelConfig } from './top-panel';
import { TopPanelService } from './top-panel.service';

@Component({
	selector: 'app-top-panel',
	templateUrl: './top-panel.component.html',
	styleUrls: ['./top-panel.component.scss']
})
export class TopPanelComponent implements OnInit {
	@Input('config') public topPanelConfig: TopPanelConfig;

	public filters: Array<FilterItem>;
	public showSortingPanel: Object;
	public showButtonSection: Object;

	constructor(private topPanelService: TopPanelService, private hrefService: HrefResolverService) { }

	public ngOnInit(): void {
		this.filters = this.topPanelService.getFilters;
		this.showSortingPanel = this.topPanelService.getShowSortingPanel();
		this.showButtonSection = this.topPanelService.getShowButtonSection();

		if (this.showButtonSection['on']) {
			this.topPanelService.setAdditionalButton.subscribe((button: AdditionalButton) => this.setAdditionalButton(button));
		}
	}

	public changeFilter(filter: FilterItem): void {
		this.topPanelService.setActiveFilter(filter.key);
	}

	public setAdditionalButton(button: AdditionalButton): void {
		this.topPanelConfig.button.href = this.hrefService.getResolvedUrl(button.href);
	}
}
